import { GridSortModel } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../hooks/use-encounter-creation-gate";
import { SurgicalHistoryControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  patientUuid?: string;
  appointmentUuid?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  status?: boolean;
  archive?: boolean;
  searchString?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePastSurgicalHistoryList = ({
  patientUuid,
  appointmentUuid,
  pagination,
  gridSorting,
  status,
  archive,
  searchString,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];
  const skip = useEncounterCreationGate();
  return useQuery({
    queryKey: [
      "patient-surgical-history-list",
      pageIndex,
      patientUuid,
      appointmentUuid,
      pageSize,
      gridSorting,
      sortData,
      status,
      archive,
      searchString,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new SurgicalHistoryControllerApi(getConfigObject())
        .getPatientSurgicalHistory(
          patientUuid,
          appointmentUuid,
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          status,
          archive,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
    enabled: enabled && !skip,
  });
};
